export default "__VITE_ASSET__5a45bbfc__"